import {
  Alert,
  Typography,
  Stack,
  colorOrToken,
  tokens,
} from '@cast/design-system';

import { InlineCode } from 'components/InlineCode';

const MIN_CASTCTL_VERSION_FOR_RELIABILITY_METRICS = 'v0.10.2';

export const ReliabilityMetricsCastctlVersionAlert = () => (
  <Alert
    color="warning"
    noIcon
    size="sm"
    testId="reliability-metrics-castctl-version-alert"
    sx={{ mt: 8 }}
  >
    <Stack gap={4}>
      <Typography
        variant="inherit"
        color={colorOrToken('grey.900', tokens.theme.fg.structural.primary)}
      >
        ⚠️ Reliability metrics require castctl{' '}
        {MIN_CASTCTL_VERSION_FOR_RELIABILITY_METRICS} or later.
      </Typography>
      <Typography
        variant="inherit"
        color={colorOrToken('grey.900', tokens.theme.fg.structural.primary)}
      >
        Run <InlineCode>castctl version</InlineCode> to check your version.
      </Typography>
    </Stack>
  </Alert>
);
